import React from 'react';
import moment from 'moment';
import { RefreshCcw, List } from 'react-feather';

const TodoPanel = ({ todos = [], isLoading = false, onRefresh, panelRef }) => {
    return (
        <div className="todo-panel">
            <div className="todo-panel-header">
                <div className="todo-panel-title">
                    <List size={16} style={{ marginRight: '6px' }} />
                    Todo List
                </div>
                <button
                    type="button"
                    className="btn btn-sm btn-light"
                    onClick={onRefresh}
                    title="Refresh todo list"
                >
                    <RefreshCcw size={14} />
                </button>
            </div>

            <div className="todo-panel-body" ref={panelRef}>
                {isLoading ? (
                    <p className="text-muted small mb-0">Loading todo items...</p>
                ) : todos.length === 0 ? (
                    <p className="text-muted small mb-0">
                        No pending todo items available for scheduling.
                    </p>
                ) : (
                    <div className="todo-list-items">
                        {todos.map((todo) => (
                            <div
                                key={todo.TodoId}
                                className="todo-item"
                                data-todo-id={todo.TodoId}
                                data-title={todo.Title}
                                data-description={todo.Description || ''}
                            >
                                <div className="todo-item-title">{todo.Title}</div>
                                {todo.Description ? (
                                    <div className="todo-item-description">{todo.Description}</div>
                                ) : null}
                                {todo.DueDate ? (
                                    <div className="todo-item-meta">
                                        Due: {moment(todo.DueDate).format('DD MMM YYYY, hh:mm A')}
                                    </div>
                                ) : null}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TodoPanel;
